<section class="ml-3 mt-4" style="height: 500px;">
  <div class="row" >
    <div class="form-group w-100 col-12">
      <label for="exampleInputEmail1">
        <h4>Product Template</h4>
      </label>
      <div class="d-flex" style="gap: 10px;">
        <!-- <div class=" d-flex">
          <select class="form-control" style="width: 15rem;" (change)="onCategoryChange()" [(ngModel)]="selectedGroupTemplate" placeholder="Select Template">
            <option value="" selected>Select Template Category</option>
            <option [value]="t?.id" *ngFor="let t of templateCategoryList">{{t?.name}}</option>
          </select>
          <span class="d-inline pl-2"><button type="submit"  (click)="openAddCategoryModal(addCategory)" class="btn btn-primary"><i class="fa fa-plus-circle" aria-hidden="true"></i></button></span>
          <span class="d-inline pl-2"><button type="submit" (click)="deleteCategory()" class="btn btn-primary"><i class="fa fa-trash" aria-hidden="true"></i></button></span>
          <span class="d-inline pl-2"><button type="submit" (click)="formAction('create')" class="btn btn-primary"><i class="fa fa-plus-circle" aria-hidden="true"></i> Create New Template</button></span>
      </div> -->

      <div class="d-flex ">
        <app-multi-dropdown placeholder="Category" [items]="categoryList" (itemSelected)="onCategoryChange($event)" style="width: 300px;"></app-multi-dropdown>
        <app-multi-dropdown placeholder="Template" [items]="templateList" (itemSelected)="selectedTemplate = $event.id" style="width: 300px;"></app-multi-dropdown>
        <!-- <select class="form-control" style="width: 15rem;" [(ngModel)]="selectedTemplate" placeholder="Select Template">
          <option value="" selected>Select Template</option>
          <option [value]="t?.id" *ngFor="let t of templateList">{{t?.templateName}}</option>
        </select> -->
        <div class="d-flex ml-1">
          
          <button type="submit" (click)="formAction('edit')" class="btn btn-primary mr-2"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</button>
          <button type="submit" (click)="formAction('view')" class="btn btn-secondary mr-2"><i class="fa fa-eye" aria-hidden="true"></i> View</button>
          <button type="submit" (click)="formAction('delete')" class="btn btn-danger"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button>
          <button type="submit" (click)="formAction('create')" class="btn btn-primary ml-2"><i class="fa fa-add" aria-hidden="true"></i> Create New Template</button>
        </div>
        
        </div>
      </div>
    </div>
  </div>

</section>

<!-- Common Product Screen -->
<app-add-shop #CommonProduct [enableMemberShop]="true" [enableTemplateView]="true" (templateViewEvents)="templateEvent($event)"></app-add-shop>
<!-- Common Product Screen -->

<ng-template #addCategory let-modal>
  <div class="modal-body">
    <div class="add_cattt d-flex justify-content-between">
      <h2>Add Template Category</h2>
      <img loading="lazy" src="../../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
    </div>
    <div class="referral-link">
      <section class="m-4">
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Enter Template Category Name"
            maxlength="500" [(ngModel)]="newTemplateCategoryName">
        </div>
      </section>
      <div class="mt-4">
        <div class="cart_btn">
          <button class="com_btn add-review-btn px-2" (click)="addTemplateCategory()">
            Save <i class="fa fa-save" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>